// src/components/ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");
  const { handleAuthFailure } = useAuth();
  const location = useLocation();

  // If no token or user, redirect to signin
  if (!token || !user) {
    // Only redirect without showing message (it's expected behavior)
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  // Token exists, render children
  // The axios interceptor will handle token expiration on API calls
  return children;
};

export default ProtectedRoute;
